import { Box, Button, Divider, Typography } from '@mui/material';

interface NodeCompleteProps {
  onClose?: () => void | undefined;
  secondaryBtn?: () => void | undefined;
}
const NodeComplete = ({ onClose, secondaryBtn }: NodeCompleteProps) => {

  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 5 }}>
        Node has been successfully created.
      </Typography>
      <Divider sx={{ my: 5, width: '100%' }} />
      <Box display="flex" justifyContent={secondaryBtn ? 'space-between' : 'center'}>
        {secondaryBtn && (
          <Button
            variant="outlined"
            onClick={secondaryBtn}
          >
            Back
          </Button>
        )}
        <Button variant="contained" color="primary" onClick={onClose}>
          Finish
        </Button>
      </Box>
    </Box>
  );
};

export default NodeComplete;
